import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, BarElement, CategoryScale, LinearScale, BarController, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, ArcElement, BarElement, BarController, LinearScale, Title, Tooltip, Legend);

interface BarChartProps {
  labelsParam: string[];
  barData: any;
  showGrid?: {
    x?: boolean;
    y?: boolean;
  };
  showLegend?: boolean;
  legendPosition?: 'top' | 'bottom' | 'left' | 'right';
}

const BarChart: React.FC<BarChartProps> = ({ labelsParam, barData, showGrid = { x: true, y: true }, showLegend = true, legendPosition = 'bottom' }) => {
  const data = {
    labels: labelsParam,
    datasets: barData,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 2,
    scales: {
      x: {
        grid: {
          display: showGrid.x, // x축 격자선 표시 여부
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          display: showGrid.y, // y축 격자선 표시 여부
        },
      },
    },
    plugins: {
      legend: {
        display: showLegend, // legend 표시 여부
        position: legendPosition, // legend 위치
      },
      tooltip: {
        callbacks: {
          title(context: any) {
            return context[0].label;
          },
        },
      },
    },
    animation: {
      onComplete: () => {
        const ctx = document.querySelector('canvas')?.getContext('2d');
        if (ctx) {
          const chart = ChartJS.getChart(ctx.canvas);
          if (chart) {
            chart.data.datasets.forEach((dataset: any, datasetIndex: number) => {
              const meta = chart.getDatasetMeta(datasetIndex);
              meta.data.forEach((element: any, index: number) => {
                const value = dataset.data[index];
                if (value > 0) {
                  ctx.fillStyle = dataset.borderColor || dataset.backgroundColor;
                  ctx.font = 'bold 1rem Arial';
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'middle';
                  ctx.fillText(value.toString(), element.x, element.y - 10);
                }
              });
            });
          }
        }
      },
    },
    interaction: {
      intersect: true,
    },
  };

  return <Bar data={data} options={options} />;
};

export default BarChart;
